import React, { useState, useEffect, useCallback } from "react";
import { Route, Switch } from "react-router";
import { useHistory } from "react-router-dom";
import Dashboard from "./components/Dashboard";

import "./custom.css";
import LoginRequest from "./components/LoginRequest";
import User from "./components/User";
import Loader from "./components/shared/Loader";
import NotFound from "./components/NotFound";
import UserRequest from "./components/UserRequest";
import { app_url } from "./components/shared/Utils";
import Header from "./components/Header";
import ResetPassword from "./components/ResetPassword";
import CreatePassword from "./components/CreatePassword";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { hotjar } from 'react-hotjar';

const App = () => {
  let history = useHistory();
  const { trackPageView, trackEvent, pushInstruction } = useMatomo();

  const [loader, setLoader] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [errorUser, setErrorUser] = useState(false);

  const showLoader = useCallback((bool) => {
    setLoader(bool);
  }, []);

  const loginSubmit = (username, password) => {
    trackEvent({ category: "Login Button Clicked", action: "click-event" });
    setLoader(true);
    fetch(`${app_url}account/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Username: username,
        Password: password,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoader(false);
        setErrorUser(false);
        if (data.token) {
          pushInstruction("setUserId", username);
          setIsLoggedIn(true);
          localStorage.setItem("islogged", data.token);
          history.push("/");
          if (data.role === "admin") {
            setIsAdmin(true);
            localStorage.setItem("isadmin", true);
          }
          trackPageView({
            customDimensions: [
              {
                id: "1",
                value: username.toLowerCase().includes("@dwellworks.com")
                  ? "Internal User"
                  : "External User",
              },
            ],
          });
        } else {
          setErrorUser(true);
        }
      })
      .catch((error) => {
        setLoader(false);
        setErrorUser(true);
      });
  };

  const handlelogout = () => {
    localStorage.removeItem("islogged");
    localStorage.removeItem("isadmin");
    setIsLoggedIn(false);
    setIsAdmin(false);
    history.push("/");
  };

  useEffect(() => {
    const islogged = localStorage.getItem("islogged");
    if (islogged) {
      setIsLoggedIn(true);
    }
    const isadmin = localStorage.getItem("isadmin");
    if (isadmin) {
      setIsAdmin(true);
    }
  }, []);

  useEffect(() => {
    hotjar.initialize('3534349', 6);
  }, []);

  return (
    <div>
      {loader ? <Loader /> : ""}
      {isLoggedIn ? (
        <>
          <Header handlelogout={handlelogout} isAdmin={isAdmin} />
          <Switch>
            <Route
              exact
              path="/"
              render={() => (
                <Dashboard
                  handlelogout={handlelogout}
                  showLoader={showLoader}
                />
              )}
            />
            {isAdmin && [
              <Route
                exact
                path="/user"
                key="user"
                render={() => (
                  <User handlelogout={handlelogout} showLoader={showLoader} />
                )}
              />,
              <Route
                exact
                path="/userrequest"
                key="userrequest"
                render={() => (
                  <UserRequest
                    handlelogout={handlelogout}
                    showLoader={showLoader}
                  />
                )}
              />,
            ]}
            <Route
              path="*"
              render={() => <NotFound handlelogout={handlelogout} />}
            />
          </Switch>
        </>
      ) : (
        <Switch>
          <Route exact path="/resetpass" render={() => <ResetPassword />} />
          <Route
            exact
            path="/user/reset-password"
            render={() => <CreatePassword showLoader={showLoader} />}
          />
          <Route
            exact
            path="*"
            render={() => (
              <LoginRequest
                loginSubmit={loginSubmit}
                errorUser={errorUser}
                showLoader={showLoader}
              />
            )}
          />
        </Switch>
      )}
    </div>
  );
};

export default App;
